import { lazyPage, type ModulePlugin } from "@keel/core";

const pos = () => import("./PurchaseOrders");
const slots = () => import("./Slots");
const PurchaseOrdersList = lazyPage(pos, "PurchaseOrdersList");
const PurchaseOrderPage = lazyPage(pos, "PurchaseOrderPage");
const NewPurchaseOrderButton = lazyPage(slots, "NewPurchaseOrderButton");
const SupplierOrdersTab = lazyPage(slots, "SupplierOrdersTab");
const ReorderButton = lazyPage(slots, "ReorderButton");

/** Purchasing: purchase orders and receiving. Ported from the prototype's `pages/purchasing`. */
const plugin: ModulePlugin = {
  key: "purchasing",
  records: { PurchaseOrder: "/purchase-orders/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Purchasing",
      items: [
        { to: "/purchase-orders", label: "Purchase orders", icon: "boxes", perm: "purchasing.orders.read" },
      ],
    },
  ],
  routes: [
    { path: "/purchase-orders", element: <PurchaseOrdersList /> },
    { path: "/purchase-orders/:id", element: <PurchaseOrderPage /> },
  ],
  commands: [
    ["New purchase order", "/purchase-orders/new", "plus", "purchasing.orders.write"],
    ["Purchase orders", "/purchase-orders", "boxes", "purchasing.orders.read"],
    ["Goods to receive", "/purchase-orders?tab=open", "warehouse", "purchasing.orders.read"],
  ],
  newMenu: [
    {
      label: "Purchase order",
      to: "/purchase-orders/new",
      perm: "purchasing.orders.write",
      section: "Documents",
    },
  ],
  sources: { purchase_order: "/purchase-orders/" },
  partyActions: [
    { key: "po", kinds: ["suppliers"], perm: "purchasing.orders.write", component: NewPurchaseOrderButton },
  ],
  partyTabs: [
    {
      key: "pos",
      label: "Purchase orders",
      kinds: ["suppliers"],
      perm: "purchasing.orders.read",
      component: SupplierOrdersTab,
    },
  ],
  productActions: [{ key: "reorder", perm: "purchasing.orders.write", component: ReorderButton }],
};
export default plugin;
